<template>
  <div>
    <h5>You have been logged out, Thank you for playing.</h5>
    <h6>~ merchbase</h6>
  </div>  
</template>
<script>
export default {
  created(){
    this.$store.dispatch('base/logout')
  },
}
</script>